export const ROLE = [
  {
    label: 'agent',
    value: 1
  },
  {
    label: 'store',
    value: 2
  }
];
// businessType
export const BUSINESS_TYPE = [
  {
    label: '换电订单',
    value: 0
  },
  {
    label: '开卡订单',
    value: 31
  },
  {
    label: '续费订单',
    value: 32
  }
];
// 订单状态
export const ORDER_STATUS = [
  {
    value: 1,
    label: 'To be paid'
  }, {
    value: 2,
    label: 'Payment has been'
  }, {
    value: 3,
    label: 'finished'
  }, {
    value: 4,
    label: 'closed'
  }]
// 电池规格
export const BATTERY_TYPE = [
  {
    value: 1,
    label: '48V'
  }, {
    value: 2,
    label: '60V'
  }, {
    value: 4,
    label: '72V'
  }]
// 卡状态
export const CARD_STATUS = [
  {
    value: 1,
    label: 'available'//可用'
  }, {
    value: 2,
    label: 'unavailable'// '不可用'
  }]
// 设备服务状态
export const SERVICE_STATUS = [
  {
    value: 1,
    label: 'Enable'
  }, {
    value: 0,
    label: 'unenable'
  }]
// 商品类型
export const GOODS_TYPE = [
  {
    value: 6,
    label: '电池'
  }, {
    value: 4,
    label: '换电卡'
  }]
//
export const primary_DeviceChargeStatusCode = [
  {
    value: 0,
    label: 'energized'
  }, {
    value: 1,
    label: 'Power out'
  }]
export const source_Type_Code = [
  {
    value: 2,
    label: 'In the electricity service'//换电服务
  },
  {
    value: 3,
    label: 'Operational records'//运维记录
  },
  {
    value: 4,
    label: 'In electrical service user additional operations'//换电服务用户额外操作
  },
  {
    value: 6,
    label: 'System request'//系统请求
  }
]
export const operate_type_code = [
  {
    value: 1,
    label: 'electricity'//通电
  },
  {
    value: 2,
    label: 'Power cut'//断电
  },
  {
    value: 3,
    label: 'Open the door'//开门
  },
  {
    value: 4,
    label: 'Close the door'//关门
  },
  {
    value: 5,
    label: 'In the battery'//放入电池
  },
  {
    value: 6,
    label: 'Take out the battery'//取出电池
  },
  {
    value: 7,
    label: 'Enable'//启用
  },
  {
    value: 8,
    label: 'unenable'//禁用
  },
  {
    value: 19,
    label: 'Offline in electricity'//离线换电
  },
  {
    value: 20,
    label: 'The query results information offline in electricity'//查询离线换电结果信息
  },
  {
    value: 31,
    label: 'Relay on'//继电器开启
  },
  {
    value: 32,
    label: 'Relay off'//继电器关闭
  },
]
export const status_Code = [
  {
    value: 1,
    label: 'In process'//处理中
  },
  {
    value: 2,
    label: 'Successful'//成功
  },
  {
    value: 3,
    label: 'failure'//失败
  },
  {
    value: 4,
    label: 'Cancel'//取消
  },
]
export const commodity_Type_Code = [
  {
    value: 6,
    label: 'battery'
  }, {
    value: 4,
    label: 'In the electric card'//换电卡
  }, {
    value: 15,
    label: 'In the electric card'//换电卡
  }]
//
export const order_Status_Code = [
  {
    value: 1,
    label: 'To be paid'//待付款
  },
  {
    value: 2,
    label: 'Payment has been'//已付款
  },
  {
    value: 3,
    label: 'finished'//已完成
  },
  {
    value: 4,
    label: 'closed'//已关闭
  },
]
export const primary_Device_Charge_Status_Code = [
  {
    value: 0,
    label: 'energized'//已通电
  }, {
    value: 1,
    label: 'Power out'//已断电
  }]
export const device_Info_type = [
  {
    value: 0,
    label: 'Charging pile'//充电桩
  },
  {
    value: 1,
    label: 'Charging port'//充电口
  },
  {
    value: 2,
    label: 'Changing cabinet'//换电桩
  },
  {
    value: 3,
    label: 'Battery'//电池
  },
  {
    value: 4,
    label: 'Charging cabinet'//充电桩
  },
  {
    value: 5,
    label: 'Battery'//海狸设备
  },
]
export const status_Code_port = [
  {
    value: -1,
    label: 'disconnected'//已断开连接
  },
  {
    value: 0,
    label: 'The battery is not plugged in'//没有插上电池
  },
  {
    value: 1,
    label: 'Battery charging'//电池充电中
  },
  {
    value: 2,
    label: 'The battery is fully charged'//电池已充满
  },
  {
    value: 3,
    label: 'Has been on the battery'//已经插上电池
  },
  {
    value: 6,
    label: 'Charging on'//充电开启中
  },
  {
    value: 11,
    label: 'Battery failure'//电池故障
  },
  {
    value: 15,
    label: 'Unable to read port state'//无法读取端口状态
  },
]
export const enable_Status_Code = [
  {
    value: 0,
    label: 'unenable'//停用
  },
  {
    value: 1,
    label: 'Enable'//启用
  },
]
export const online_Flag_status = [
  {
    label: "全部",
    value: ''
  },
  {
    label: "在线",
    value: '1'
  },
  {
    label: "离线",
    value: '2'
  },
];
export const door_Status_Code = [
  {
    value: 1,
    label: 'open'//开启
  },
  {
    value: 2,
    label: 'Shut down'//关闭
  },
]
export const voucher_Type = [
  {
    value: 3,
    label: 'In the electric timer card'//换电卡
  },
  {
    value: 101,
    label: 'Measured card'//换电卡
  },
  {
    value: 4,
    label: 'Battery holding certificate'//'电池持有凭证'
  },
]
export const currency_type = [
  {
    label: "RMB",
    value: '1'
  },
  {
    label: 'Thai Baht',
    value: '2'
  },
]
export const compulsory_purchase = [
  {
    label: "open",
    value: '1'
  },
  {
    label: "closed",
    value: '2'
  },
]



// WEBPACK FOOTER //
// ./src/utils/constant.js